module.exports = __webpack_public_path__ + "img/empty_cart.2bb47135.png";